import { LARGE, MEDIUM, SMALL } from 'lib/DeviceScreen';
import adCss from 'components/styles/CenteredAd';
import { LEADERBOARD } from 'lib/GoogleAds/Sizes';
import { AdGlobalRefreshContext } from 'contexts/AdGlobalRefreshContext';
import { useContext } from 'react';
import { colors, screen } from 'components/styles/variables';
import ConditionalRefreshAd from './ConditionalRefreshAd';

export default function LeaderboardAds(): JSX.Element {
  const { shouldGlobalAdsRefresh } = useContext(AdGlobalRefreshContext);

  return (
    <div className="leaderboard-ads-container">
      <ConditionalRefreshAd
        adConfig={{
          dimensions: [[728, 90]],
          targeting: { inLine: 1 },
          screenSizes: [LARGE, MEDIUM],
        }}
        placeholderSize={LEADERBOARD}
        className={`${adCss.className}`}
        shouldRefresh={shouldGlobalAdsRefresh}
      />
      <ConditionalRefreshAd
        adConfig={{
          dimensions: [[728, 90]],
          targeting: { inLine: 1 },
          screenSizes: [SMALL],
        }}
        placeholderSize={LEADERBOARD}
        className={`${adCss.className}`}
        shouldRefresh={shouldGlobalAdsRefresh}
      />
      {adCss.styles}
      <style jsx>{`
        .leaderboard-ads-container {
          background-color: ${colors.G1};
        }

        @media (min-width: ${screen.smMin}) {
          .leaderboard-ads-container {
            padding: 10px 0;
          }
        }
      `}</style>
    </div>
  );
}
